module.exports = __webpack_public_path__ + "static/media/thumbnail-xfolio.5a33889d.png";